import { YEAR_SECONDS } from "@/lib/datetime/durations";
import { rootDomainFromHostname } from "@/lib/routing/host-classification";

/**
 * The brand kit a browser wears (Dylan, 2026-10-23) lives in one cookie: the Brand images setting
 * writes it when its user picks a kit, and the root layout reads it, so the server paints the kit's
 * images from the first frame. It is set on the root domain, so the CRM, admin, the portal and the
 * site wear the same kit in that browser. No cookie is the Default kit. A plain module, so the server
 * reads the very name the client writes.
 */
export const BRAND_KIT_COOKIE_NAME = "dw-brand-kit";

/** The kit id this browser's cookie names, or null for the Default kit. Client only. */
export function readBrandKitCookie(): string | null {
    const entry = document.cookie.split("; ").find((part) => part.startsWith(`${BRAND_KIT_COOKIE_NAME}=`));
    return entry ? decodeURIComponent(entry.slice(BRAND_KIT_COOKIE_NAME.length + 1)) : null;
}

/** Writes the kit's id, or clears the cookie for the Default kit, on every host of this browser's root domain. */
export function writeBrandKitCookie(kitId: string | null): void {
    const root = rootDomainFromHostname(window.location.hostname);
    const domain = root === "localhost" ? "" : `; domain=${root}`;
    const value = kitId ? `${encodeURIComponent(kitId)}; max-age=${YEAR_SECONDS}` : "; max-age=0";
    document.cookie = `${BRAND_KIT_COOKIE_NAME}=${value}; path=/; samesite=lax; secure${domain}`;
}
